import { STORAGE_KEYS } from "~/types/Storage";

export const StorageKeys = {
    quiz: {
        completed: (category: string) => category ? `${category}-${STORAGE_KEYS.QUIZ_COMPLETED}` : STORAGE_KEYS.QUIZ_COMPLETED,
        completedId: (category: string) => category ? `${category}-${STORAGE_KEYS.QUIZ_COMPLETED_ID}` : STORAGE_KEYS.QUIZ_COMPLETED_ID,
    },   
};
